import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EBnibBuyOrderSortField,
  IBnibBuyOrder,
  PBnibBuyOrderFilter,
} from "src/core/bnibBuyOrder/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IBnibBuyOrderState {
  bnibBuyOrders: IBnibBuyOrder[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IBnibBuyOrderState = {
  bnibBuyOrders: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "bnib-buy-order/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "bnib-buy-order/FETCH_SUCCEEDED";
const FETCH_FAILED = "bnib-buy-order/FETCH_FAILED";
const POLLING_START_REQUESTED = "bnib-buy-order/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "bnib-buy-order/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IBnibBuyOrder[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PBnibBuyOrderFilter;
    pagination: IPagination;
    sorts: ISort<EBnibBuyOrderSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IBnibBuyOrderState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IBnibBuyOrderState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.bnibBuyOrders = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
